import Axios from 'axios';
import { ES_URL } from '../../../../../../config';

const EsTopAsn = (SearchField, SearchValue, getElements, changeElements, startTime, endTime) => {

  const elements = getElements();

  const query = {
    'size': 0,
    '_source': {
      'excludes': []
    },
    'aggs': {
      'ASN': {
        'terms': {
          'field': 'ASN Description',
          'size': 25
        }
      }
    },
    'query': {
      'bool': {
        'must': [
          {
            'match_all': {}
          },
          {
            'range': {
              '@timestamp': {
                'gte': startTime,
                'lte': endTime,
                'format': 'epoch_millis'
              }
            }
          },
          {
            'match_phrase': {
              [SearchField]: {
                'query': SearchValue
              }
            }
          }
        ]
      }
    }
  };

  Axios.post(`${ES_URL}/filebeat-*/_search`, query).then(resp => {
    const buckets = resp.data.aggregations.ASN.buckets;
    buckets.map(bucket => {
      elements.push(
        {
          data: { id: bucket.key, size: Math.log10(bucket.doc_count+1) * 10, entityType: 'NormalASN' }
        }
      );
      elements.push(
        {
          data: { id: `${SearchValue}:${bucket.key}`, source: SearchValue, target: bucket.key }
        }
      );
    });
    changeElements(elements);
  });


};

export default EsTopAsn;
